import { useContext, useEffect, useRef } from 'react';

import ConfigContext from 'app/common/ConfigContext';

const useIframeHeight = () => {
  const { widgetId, origin } = useContext(ConfigContext);

  const containerRef = useRef<HTMLDivElement>(null);
  const lastHeightRef = useRef<number>(0);

  useEffect(() => {
    if (typeof window === 'undefined' || !origin || !widgetId) return;

    const sendHeight = () => {
      if (!containerRef.current) return;

      const height = containerRef.current.scrollHeight;

      // Only send if height has changed
      if (height !== lastHeightRef.current) {
        lastHeightRef.current = height;

        const message = {
          type: 'PANDASCORE_WIDGET_HEIGHT_UPDATE',
          height,
          widgetId
        };

        window.parent.postMessage(message, origin);
      }
    };

    // Send initial height
    sendHeight();

    // Create ResizeObserver to watch for height changes
    const resizeObserver = new ResizeObserver(() => {
      sendHeight();
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    // Cleanup
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return containerRef;
};

export default useIframeHeight;
